import React, { useEffect, useRef, useState } from "react";
import "./Upgrade.scss";

import { FaChevronRight } from "react-icons/fa";
import { FaBookmark } from "react-icons/fa";

import { FaLightbulb } from "react-icons/fa";
import { GiCrown } from "react-icons/gi";
import { MdOutlineWorkspacePremium } from "react-icons/md";

import { Link, useLocation, useNavigate } from "react-router-dom";
import CustomButton from "../../components/CustomButton/CustomButton";
import ROUTES from "../../constants/routes";
import { useSelector } from "react-redux";
import LearnMore from "./LearnMore/LearnMore";
import { IoIosArrowBack, IoMdClose } from "react-icons/io";
import { useViewPortDetector } from "../../helpers/viewPortDetector";
import UpgradePayment from "./Payment/UpgradePayment";
import { toast } from "react-toastify";

const Upgrade = () => {
  const { currentViewPort } = useViewPortDetector();
  const scrollRef = useRef(null);
  const { plans: subsPlans } = useSelector(
    (state) => state.subscriptionReducer.value
  );
  const { is_admin } = useSelector((state) => state.userReducer.value);
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const selectedId = query.get("id") || null;
  const navigate = useNavigate();
  const [selectedIndex, setSelectedIndex] = useState(1);
  const [scrollActive, setScrollActive] = useState(false);
  const [slideList, setSlideList] = useState([]);

  const [selectedPackage, setSelectedPackage] = useState("monthly");

  useEffect(() => {
    let tempPlans = subsPlans?.map((el, i) => {
      const array = el?.features?.length > 0 ? [...el?.features] : [];
      let lastThree =
        el?.pricing?.monthly?.price > 0 ? array.slice(-3) : array.slice(0, 3);

      if (el?.name === "Pro") {
        if (array.length >= 3) {
          const middleIndex = Math.floor(array.length / 2) - 1;
          lastThree = array.slice(middleIndex, middleIndex + 3);
        }
      }

      lastThree = lastThree?.map((el) => {
        return `${el?.name} ${el?.value ? `- ${el?.value}` : ""} ${
          el?.tag === "analytics" ? (el?.value ? "days" : "") : ""
        }`;
      });
      return {
        monthly_id: el?.pricing?.monthly?.id,
        yearly_id: el?.pricing?.yearly?.id,
        heading: el?.name,
        interval:
          selectedPackage === "monthly" && el?.pricing?.monthly?.id
            ? "Per Month"
            : selectedPackage === "yearly" && el?.pricing?.yearly?.id
            ? "Per Year"
            : "",
        icon:
          el?.name === "Free" ? (
            <FaLightbulb />
          ) : el?.name === "Pro" ? (
            <GiCrown />
          ) : (
            <MdOutlineWorkspacePremium />
          ),
        desc: el?.description,
        color: el?.color,
        price: `$ ${
          selectedPackage === "monthly" && el?.pricing?.monthly?.id
            ? el?.pricing?.monthly?.price
            : selectedPackage === "yearly" && el?.pricing?.yearly?.id
            ? el?.pricing?.yearly?.price
            : ""
        }`,
        perMonth: (
          <>
            {`$ ${el?.pricing?.monthly?.price}`}
            <span>/mo</span>{" "}
          </>
        ),
        perYear: (
          <>
            {`$ ${el?.pricing?.yearly?.price}`}
            <span>/year</span>{" "}
          </>
        ),
        features: lastThree,
      };
    });

    console.log(tempPlans);

    let activeIndex = selectedId
      ? tempPlans?.findIndex(
          (el) =>
            el?.monthly_id === Number(selectedId) ||
            el?.yearly_id === Number(selectedId)
        )
      : 1;

    activeIndex = activeIndex < 0 ? 1 : activeIndex;

    let activePackage =
      tempPlans[activeIndex]?.monthly_id === Number(selectedId)
        ? "monthly"
        : tempPlans[activeIndex]?.yearly_id === Number(selectedId)
        ? "yearly"
        : "monthly";

    setSelectedIndex(activeIndex);
    setSlideList(tempPlans);
    setSelectedPackage(activePackage);
  }, [subsPlans, selectedId]);

  const handleScroll = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        block: "nearest",
        behavior: "smooth",
        inline: "center",
      });
    }
  };

  const handleChangeSelected = (index) => {
    setSelectedIndex(index);
  };
  const sliderRef = useRef(null);
  const [scrollLeft, setScrollLeft] = useState(0);
  const [firstRender, setFirstRender] = useState(true);

  useEffect(() => {
    if (!scrollActive) {
      setTimeout(() => {
        handleScroll(`slide-item${selectedIndex}`);
      }, 10);
      setTimeout(() => {
        setFirstRender(false);
      }, 1000);
    }
  }, [selectedIndex]);

  const handleHorizontalScroll = () => {
    if (sliderRef.current && !firstRender) {
      const newScrollLeft = sliderRef.current.scrollLeft;

      const distanceScrolled = newScrollLeft - scrollLeft;

      const direction = distanceScrolled > 0 ? "right" : "left";

      let activeItemWidth = 0;
      const element = document.getElementById(`slide-item${selectedIndex}`);

      if (element) {
        activeItemWidth = element.getBoundingClientRect().width;
      }

      if (Math.abs(distanceScrolled) >= activeItemWidth / 2) {
        setScrollLeft(newScrollLeft);
        setScrollActive(true);

        setTimeout(() => {
          if (direction === "left") {
            selectedIndex !== 0 && setSelectedIndex((pre) => pre - 1);
          } else {
            selectedIndex !== slideList.length - 1 &&
              setSelectedIndex((pre) => pre + 1);
          }
          setScrollActive(false);
        }, 11);
      }
    }
  };

  const handleScrollLearnMoreIntoView = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollIntoView({
        block: "nearest",
        behavior: "smooth",
        inline: "center",
      });
    }
  };

  const [openPayment, setOpenPayment] = useState(false);

  return (
    <div className="upgrade-page-wrapper">
      <div
        className={`desktop-navbar box-shadow ${openPayment ? "static" : ""}`}
      >
        <div
          className="back"
          onClick={() => {
            navigate("/");
          }}
        >
          <IoIosArrowBack />
        </div>
        <p>{ROUTES.upgrade.title}</p>
      </div>
      <div className="upgrade-page-container">
        {/* <div className="desktop-upgrade-headings">
          <p>Pricing</p>
          <p className="title">Boost your productivity with expanded access</p>
          <span>
            We're ready to help you make your business successful. Explore all
            the plans we offer and find the one that is most suitable for your
            current situation
          </span>
        </div> */}
        <div className="upgrade-page">
          <div className="slider-container">
            <div
              className="slider-wrapper"
              ref={sliderRef}
              onScroll={handleHorizontalScroll}
            >
              {slideList.map((item, i) => {
                return (
                  <div
                    className={`slide-item ${selectedIndex === i ? "pro" : ""}`}
                    key={i}
                    onClick={() => {
                      handleChangeSelected(i);
                    }}
                    id={`slide-item${i}`}
                    data-index={i}
                  >
                    <p className="heading">{item.heading}</p>

                    <div className="middle">
                      <p className="icon">{item.icon}</p>
                      <p className="desc">{item.desc}</p>

                      <p className="price">
                        {item.price}
                        <span>{item.interval}</span>
                      </p>

                      <div className="features">
                        {item.features.map((el, index) => {
                          return <p key={index}>{el}</p>;
                        })}
                      </div>
                    </div>

                    <div className="lower">
                      <Link
                        className="link"
                        to={
                          currentViewPort === "desktop"
                            ? "#"
                            : ROUTES.upgradeLearnMore.path
                        }
                        onClick={() => {
                          if (currentViewPort === "desktop") {
                            handleScrollLearnMoreIntoView();
                          }
                        }}
                      >
                        Learn More
                      </Link>

                      <p>
                        Subscription does not include any contracts. Unsubscribe
                        any time you want.
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="navigation-dots">
            {slideList.map((el, i) => {
              return (
                <span
                  className={i === selectedIndex ? "active" : ""}
                  key={i}
                  onClick={() => {
                    handleChangeSelected(i);
                  }}
                ></span>
              );
            })}
          </div>

          <div className="subs-options">
            {slideList[selectedIndex] &&
              slideList[selectedIndex].monthly_id && (
                <div
                  className={`button ${
                    selectedPackage === "monthly" ? "active" : ""
                  }`}
                  onClick={() => {
                    setSelectedPackage("monthly");
                  }}
                >
                  <div className="svg">
                    <FaBookmark />
                  </div>
                  <div className="left">
                    <p>1 Month</p>
                    <span>Most Affordable</span>
                  </div>

                  <p className="price">
                    {slideList[selectedIndex]
                      ? slideList[selectedIndex].perMonth
                      : ""}
                  </p>
                </div>
              )}
            {slideList[selectedIndex] && slideList[selectedIndex].yearly_id && (
              <div
                className={`button ${
                  selectedPackage === "yearly" ? "active" : ""
                }`}
                onClick={() => {
                  setSelectedPackage("yearly");
                }}
              >
                <div className="svg">
                  <FaBookmark />
                </div>
                <div className="left">
                  <p>12 Months</p>
                  <span>Most Popular</span>
                </div>
                <p className="price">
                  {slideList[selectedIndex]
                    ? slideList[selectedIndex].perYear
                    : ""}
                </p>
              </div>
            )}
          </div>

          <div className="subscribe-footer">
            <div className="buttonWrapper">
              <CustomButton
                name={`Subscribe ${selectedPackage}`}
                type={"button"}
                color={"primary"}
                bigButton={true}
                handleSubmit={() => {
                  if (currentViewPort === "desktop") {
                    if (is_admin) {
                      setOpenPayment(true);
                    } else {
                      toast.dismiss(); toast.info(
                        "You do not have sufficient permissions to perform this action. Please contact your administrator."
                      );
                    }
                  } else {
                    const selected_plan = slideList[selectedIndex]
                      ? slideList[selectedIndex]?.monthly_id
                      : 0;
                    navigate(ROUTES.upgradePayment.path, {
                      state: {
                        selected: selected_plan,
                        selectedBilling: selectedPackage,
                      },
                    });
                  }
                }}
              />
              <FaChevronRight className="sideArrow" />
            </div>

            <p className="terms">
              Read our{" "}
              <a href={"https://daikoapp.com/index.php/73-2/"} target="blank">
                Terms of use
              </a>
            </p>
          </div>
        </div>
        <div className="desktop-learmore" ref={scrollRef}>
          <LearnMore desktopView={true} />
        </div>
      </div>

      {openPayment && (
        <div
          className="back-blur"
          onClick={() => {
            setOpenPayment(false);
          }}
        ></div>
      )}

      {currentViewPort === "desktop" && (
        <div className={`desktop-payment-model ${openPayment ? "active" : ""}`}>
          <div className="desktop-navbar">
            <p>Payment</p>
            <div className="last-tag-svg">
              <IoMdClose
                onClick={() => {
                  setOpenPayment(false);
                }}
              />
            </div>
          </div>
          <UpgradePayment
            desktopView={true}
            selectedId={
              slideList[selectedIndex]
                ? slideList[selectedIndex]?.monthly_id
                : 0
            }
            selectedPlanBilling={selectedPackage}
          />
        </div>
      )}
    </div>
  );
};

export default Upgrade;
